import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import { varAlpha } from 'minimal-shared/utils';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Logo } from '../logo';

// ----------------------------------------------------------------------

export function AnimateLogoZoom(t0) {
  const $ = _c(22);
  let logo;
  let other;
  let slotProps;
  let sx;
  if ($[0] !== t0) {
    ({
      logo,
      slotProps,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = logo;
    $[2] = other;
    $[3] = slotProps;
    $[4] = sx;
  } else {
    logo = $[1];
    other = $[2];
    slotProps = $[3];
    sx = $[4];
  }
  let t1;
  if ($[5] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[5] = sx;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = [...t1];
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      scale: [1, 0.9, 0.9, 1, 1],
      opacity: [1, 0.48, 0.48, 1, 1]
    };
    t4 = {
      duration: 2,
      repeatDelay: 1,
      repeat: Infinity,
      ease: "easeInOut"
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== logo || $[12] !== slotProps?.logo) {
    t5 = logo ?? <Logo disabled={true} {...slotProps?.logo} sx={[{
      width: 48,
      height: 48
    }, ...(Array.isArray(slotProps?.logo?.sx) ? slotProps?.logo?.sx ?? [] : [slotProps?.logo?.sx])]} />;
    $[11] = logo;
    $[12] = slotProps?.logo;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <m.span animate={t3} transition={t4}>{t5}</m.span>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LogoZoomPrimaryOutline animate={{
      scale: [1.6, 1, 1, 1.6, 1.6],
      rotate: [270, 0, 0, 270, 270],
      opacity: [0.25, 1, 1, 1, 0.25],
      borderRadius: ["25%", "25%", "50%", "50%", "25%"]
    }} transition={{
      ease: "linear",
      duration: 3.2,
      repeat: Infinity
    }} />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LogoZoomSecondaryOutline animate={{
      scale: [1, 1.2, 1.2, 1, 1],
      rotate: [0, 270, 270, 0, 0],
      opacity: [1, 0.25, 0.25, 0.25, 1],
      borderRadius: ["25%", "25%", "50%", "50%", "25%"]
    }} transition={{
      ease: "linear",
      duration: 3.2,
      repeat: Infinity
    }} />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== other || $[19] !== t2 || $[20] !== t6) {
    t9 = <LogoZoomRoot sx={t2} {...other}>{t6}{t7}{t8}</LogoZoomRoot>;
    $[18] = other;
    $[19] = t2;
    $[20] = t6;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
const LogoZoomRoot = styled('div')(() => ({
  width: 120,
  height: 120,
  alignItems: 'center',
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center'
}));
const LogoZoomPrimaryOutline = styled(m.span)(({
  theme
}) => ({
  position: 'absolute',
  width: 'calc(100% - 20px)',
  height: 'calc(100% - 20px)',
  border: `solid 3px ${varAlpha(theme.vars.palette.primary.darkChannel, 0.24)}`
}));
const LogoZoomSecondaryOutline = styled(m.span)(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  border: `solid 8px ${varAlpha(theme.vars.palette.primary.darkChannel, 0.24)}`
}));
export function AnimateLogoRotate(t0) {
  const $ = _c(17);
  let logo;
  let other;
  let slotProps;
  let sx;
  if ($[0] !== t0) {
    ({
      logo,
      slotProps,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = logo;
    $[2] = other;
    $[3] = slotProps;
    $[4] = sx;
  } else {
    logo = $[1];
    other = $[2];
    slotProps = $[3];
    sx = $[4];
  }
  let t1;
  if ($[5] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[5] = sx;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = [...t1];
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== logo || $[10] !== slotProps?.logo) {
    t3 = logo ?? <Logo disabled={true} {...slotProps?.logo} sx={[{
      height: 48
    }, ...(Array.isArray(slotProps?.logo?.sx) ? slotProps?.logo?.sx ?? [] : [slotProps?.logo?.sx])]} />;
    $[9] = logo;
    $[10] = slotProps?.logo;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LogoRotateBackground animate={{
      rotate: 360
    }} transition={{
      duration: 10,
      ease: "linear",
      repeat: Infinity
    }} />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== other || $[14] !== t2 || $[15] !== t3) {
    t5 = <LogoRotateRoot sx={t2} {...other}>{t3}{t4}</LogoRotateRoot>;
    $[13] = other;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
const LogoRotateRoot = styled('div')(() => ({
  width: 96,
  height: 96,
  alignItems: 'center',
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center'
}));
const LogoRotateBackground = styled(m.span)(({
  theme
}) => ({
  opacity: 0.16,
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  position: 'absolute',
  backgroundImage: `linear-gradient(135deg, transparent 50%, ${theme.vars.palette.primary.main} 100%)`,
  transition: theme.transitions.create(['opacity'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  })
}));
export function AnimateLogoSpinner(t0) {
  const $ = _c(18);
  let logo;
  let other;
  let slotProps;
  let sx;
  if ($[0] !== t0) {
    ({
      logo,
      slotProps,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = logo;
    $[2] = other;
    $[3] = slotProps;
    $[4] = sx;
  } else {
    logo = $[1];
    other = $[2];
    slotProps = $[3];
    sx = $[4];
  }
  let t1;
  if ($[5] !== sx) {
    t1 = Array.isArray(sx) ? sx : [sx];
    $[5] = sx;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = [...t1];
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== logo || $[10] !== slotProps?.logo) {
    t3 = logo ?? <Logo disabled={true} {...slotProps?.logo} sx={[{
      height: 48
    }, ...(Array.isArray(slotProps?.logo?.sx) ? slotProps?.logo?.sx ?? [] : [slotProps?.logo?.sx])]} />;
    $[9] = logo;
    $[10] = slotProps?.logo;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg width={0} height={0}><defs><linearGradient id="spinner_gradient" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="var(--palette-primary-main)" /><stop offset="100%" stopColor="var(--palette-primary-lighter)" /></linearGradient></defs></svg>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SpinnerGradientRoot>{t4}<CircularProgress size={116} thickness={0.8} sx={{
        "svg circle": {
          stroke: "url(#spinner_gradient)"
        }
      }} /></SpinnerGradientRoot>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== other || $[15] !== t2 || $[16] !== t3) {
    t6 = <LogoSpinnerRoot sx={t2} {...other}>{t3}{t5}</LogoSpinnerRoot>;
    $[14] = other;
    $[15] = t2;
    $[16] = t3;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
const LogoSpinnerRoot = styled('div')(() => ({
  width: 96,
  height: 96,
  alignItems: 'center',
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center'
}));
const SpinnerGradientRoot = styled('div')(() => ({
  alignItems: 'center',
  position: 'absolute',
  display: 'inline-flex',
  justifyContent: 'center'
}));